import Vue from 'vue';
import Velocity from 'velocity-animate';

// 注册一个全局自定义指令
Vue.directive('slideIn', {
  // 当被绑定的元素插入到 DOM 中时
  inserted(el, binding, Vnode, oldVnode) {
    // 动画
    el.style.position = 'relative';
    el.style.left = '100px';
    el.style.opacity = 0;

    Velocity(el, {
      left: 0,
      opacity: 1
    }, {
      duration: binding.value || 250
    });
  }
});
